// Bookie Midnight ("Tunqush Gala") — variant that renders the
// standalone HTML template inside a full-bleed iframe. The HTML
// lives at /templates/bookie-midnight.html and was repurposed from a
// midnight wedding into a CORPORATE BLACK-TIE GALA: dark midnight
// ink shell, gold ornaments, paper-light body text, crescent moon +
// scattered tiny gold stars. Sections: hero → welcome letter →
// agenda (5 timestamps) → speaker grid (3) → dress code → venue +
// map → RSVP → footer. The customizer script inside the HTML reads
// names/date/venue/etc. from the iframe URL and swaps the
// "Sharq Texnologiya" / "Hyatt Regency" / "30.10.2026" mocks before
// first paint. Because the occasion is corporate, `names` is a
// SINGLE company name (no ampersand split).
//
// Payload values go via the URL (not postMessage) because the
// in-iframe customizer must run before the IntersectionObserver
// attaches. No `audio` param — this template is intentionally silent
// (corporate gala, no background music).

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/bookie-midnight.html";

export function BookieMidnightStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) {
    // Convert dd.mm.yyyy -> ISO yyyy-mm-dd for the customizer.
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  // Demo / preview surfaces leave ctx.slug undefined.
  if (ctx.slug) params.set("slug", ctx.slug);
  // This template is intentionally silent — no audio param.
  // Cache buster — bump when the static HTML changes.
  params.set("v", "3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Tunqush Gala"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#1A1814",
      }}
    />
  );
}
